import React, {useState} from "react";
import {Link} from "react-router-dom";
import {useAppSelector} from "../../../utils/Hooks";

interface SMSSendersTableProps {
}

export const SMSSendersTable: React.FC<SMSSendersTableProps> = () => {

    const offlineReasonsState = useAppSelector(state => state.SMSSenders);

    return (
        <>
            <table className="data">
                <thead>
                <tr>
                    <th>Nimi</th>
                    <th className="right w150"></th>
                </tr>
                </thead>
                <tbody>
                {offlineReasonsState.SMSSenders.map(row => {
                    return (
                        <tr key={row.id}>
                            <td>
                                {row.name}
                            </td>
                            <td className="action">
                                <Link to={`/sms-senders/${row.id}/modify`}>Muuda</Link>
                                <span>|</span>
                                <Link to={`/sms-senders/${row.id}/delete`}>Kustuta</Link>
                            </td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
            <ul className="table-actions">
                <li>
                    <Link to="/sms-senders/new">
                        <strong>Lisa uus saatja</strong>
                    </Link>
                </li>
            </ul>
        </>
    );

}